import { Injectable } from '@angular/core';
import { Feature } from './feature.enum';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private readonly defaultFlags: Record<Feature, boolean> = {
    [Feature.Move]: environment.flags.move,
    [Feature.Notification]: environment.flags.notification,
    [Feature.AskNewCaution]: environment.flags.askNewCaution,
    [Feature.Refund]: environment.flags.refund,
    [Feature.MaintenanceMode]: environment.flags.maintenance,
  };

  isFeatureEnabled(feature: Feature): boolean {
    const flag = localStorage.getItem(feature);
    return flag !== null ? flag === 'true' : this.defaultFlags[feature];
  }
}
